import {Component, Input, OnInit} from "@angular/core";
import {DatePipe, NgForOf} from "@angular/common";
import {SAStatusBadge} from "./isf.sa.status";
import {ISFBillStatus} from "../../shipper";


@Component({
	selector: 'sa-bill-list',
	standalone: true,
	imports: [
		DatePipe,
		NgForOf,
		SAStatusBadge
	],
	template: `
        <table class="table table-sm table-striped table-bordered">
            <tr *ngFor="let s of statusData; let i = index;">
                <td style="width: 30px;">
                    <sa-status [status]="s.code"></sa-status>
                </td>
                <td>{{ s.message }}</td>
                <td>{{ s.dateTime | date:'medium' }}</td>
            </tr>
        </table>
	`,
	styles:[`
		table tr td{padding: 4px; font-size: 14px;}
	`]
})
export class IsfSaBillList implements OnInit{
	
	@Input()
	billStatus:Array<ISFBillStatus> = [];
	
	statusData:Array<ISFBillStatus> = [];
	
	ngOnInit(): void {
		
		this.statusData = this.billStatus.sort((a,b) => {
			
			if(new Date(a.dateTime).getTime() > new Date(b.dateTime).getTime()){return -1;}
			if(new Date(a.dateTime).getTime() < new Date(b.dateTime).getTime()){return 1;}
			return 0 ;
		});
	}
	
}
